import { FieldInfo } from "@/components/forms/FieldInfo";

export function Field({
  label, children, error, hint, required, info,
}: {
  label: React.ReactNode; children: React.ReactNode; error?: string; hint?: string; required?: boolean; info?: string;
}) {
  return (
    <div className="block mb-3">
      <div className="text-xs text-muted-foreground mb-1 flex items-center justify-between">
        <span className="flex-1 flex items-center">{label}{required && <span className="text-destructive"> *</span>}</span>
        {info && typeof label === "string" && <FieldInfo help={info} label={label} />}
      </div>
      {children}
      {hint && !error && <div className="text-[11px] text-muted-foreground mt-1">{hint}</div>}
      {error && <div className="text-[11px] text-destructive mt-1">{error}</div>}
    </div>
  );
}

export function Row({ children }: { children: React.ReactNode }) {
  return <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3">{children}</div>;
}

export function SectionHeading({ children, first }: { children: React.ReactNode; first?: boolean }) {
  return (
    <div className={`text-[11px] uppercase tracking-wide text-muted-foreground font-semibold mb-2 ${first ? "" : "mt-5 pt-4 border-t border-border"}`}>
      {children}
    </div>
  );
}
